interface SimpleStorage {
  getItem(key: string): string | null | undefined
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

let safeLocalStorage: SimpleStorage | undefined

class MockedLocalStorage implements SimpleStorage {
  private map: Map<string, string>

  constructor() {
    this.map = new Map()
  }

  getItem(key: string): string | undefined {
    return this.map.get(key)
  }

  setItem(key: string, value: string): void {
    this.map.set(key, value)
  }

  removeItem(key: string): void {
    this.map.delete(key)
  }
}

function localStorageAvailable(): boolean {
  try {
    const x = '__storage_test__'
    window.localStorage.setItem(x, x)
    window.localStorage.removeItem(x)
    return true
  } catch {
    return false
  }
}

function detectLocalStorage(): SimpleStorage {
  if (localStorageAvailable()) {
    return window.localStorage
  }
  return new MockedLocalStorage()
}

export function __reset(): void {
  safeLocalStorage = undefined
}

// return localStorage, or just a Map, depending on whether localStorage is available
export default function (): SimpleStorage {
  safeLocalStorage = safeLocalStorage || detectLocalStorage()
  return safeLocalStorage
}
